import { render, staticRenderFns } from "./CategoryLabel.vue?vue&type=template&id=49a906c0"
import script from "./CategoryLabel.vue?vue&type=script&lang=js"
export * from "./CategoryLabel.vue?vue&type=script&lang=js"
import style0 from "./CategoryLabel.vue?vue&type=style&index=0&id=49a906c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports